module.exports = __webpack_public_path__ + "static/media/logo.17a5a13f.png";